// Flag used for fallback layer
export const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
// iPad Pro identifies as Macintosh, so some additional check is needed
export const isIpadPro = /Macintosh/.test(navigator.userAgent) && !!navigator.maxTouchPoints;
export const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
